import { TFieldTypeConfigs, TViewConfigs } from '@/types/TSmartCRM';
import { EFieldType, EFilterOperator, EViewType } from 'src/enums/ESmartCRM';

export const FIELD_TYPE_CONFIGS: TFieldTypeConfigs = {
	[EFieldType.TEXT]: {
		type: EFieldType.TEXT,
		icon: 'FileTextOutlined',
		label: 'Text',
		description: 'Names, notes, descriptions',
		example: 'Customer name, special requests',
		operators: [EFilterOperator.EQUALS, EFilterOperator.CONTAINS, EFilterOperator.STARTS_WITH],
		hasOptions: false,
	},
	[EFieldType.SELECT]: {
		type: EFieldType.SELECT,
		icon: 'SelectOutlined',
		label: 'Pick from List',
		description: 'Pick from predefined options',
		example: 'Service type, preferred day',
		operators: [EFilterOperator.EQUALS, EFilterOperator.IN],
		hasOptions: true,
	},
	[EFieldType.DATE]: {
		type: EFieldType.DATE,
		icon: 'CalendarOutlined',
		label: 'Date',
		description: 'Dates and times',
		example: 'Customer since, last visit',
		operators: [
			EFilterOperator.EQUALS,
			EFilterOperator.GREATER_THAN,
			EFilterOperator.LESS_THAN,
			EFilterOperator.GREATER_EQUAL,
			EFilterOperator.LESS_EQUAL,
		],
		hasOptions: false,
	},
	[EFieldType.BOOLEAN]: {
		type: EFieldType.BOOLEAN,
		icon: 'CheckOutlined',
		label: 'Yes/No',
		description: 'True or false values',
		example: 'VIP customer, newsletter subscriber',
		operators: [EFilterOperator.EQUALS],
		hasOptions: false,
	},
	[EFieldType.NUMBER]: {
		type: EFieldType.NUMBER,
		icon: 'NumberOutlined',
		label: 'Number',
		description: 'Quantities, amounts, counts',
		example: 'Annual visits, average spend',
		operators: [
			EFilterOperator.EQUALS,
			EFilterOperator.GREATER_THAN,
			EFilterOperator.LESS_THAN,
			EFilterOperator.GREATER_EQUAL,
			EFilterOperator.LESS_EQUAL,
		],
		hasOptions: false,
	},
	[EFieldType.MULTISELECT]: {
		type: EFieldType.MULTISELECT,
		icon: 'UnorderedListOutlined',
		label: 'Multiple Items',
		description: 'Select multiple options',
		example: 'Services used, vehicle types',
		operators: [EFilterOperator.CONTAINS, EFilterOperator.IN],
		hasOptions: true,
	},
};

export const FILTER_OPERATOR_LABELS = {
	[EFilterOperator.EQUALS]: 'Equals',
	[EFilterOperator.CONTAINS]: 'Contains',
	[EFilterOperator.STARTS_WITH]: 'Starts With',
	[EFilterOperator.GREATER_THAN]: 'Greater Than',
	[EFilterOperator.LESS_THAN]: 'Less Than',
	[EFilterOperator.GREATER_EQUAL]: 'Greater Than or Equal',
	[EFilterOperator.LESS_EQUAL]: 'Less Than or Equal',
	[EFilterOperator.IN]: 'Is One Of',
};

export const OPERATOR_BACKEND_MAP = {
	[EFilterOperator.EQUALS]: 'eq',
	[EFilterOperator.CONTAINS]: 'contains',
	[EFilterOperator.STARTS_WITH]: 'startsWith',
	[EFilterOperator.GREATER_THAN]: 'gt',
	[EFilterOperator.LESS_THAN]: 'lt',
	[EFilterOperator.GREATER_EQUAL]: 'gte',
	[EFilterOperator.LESS_EQUAL]: 'lte',
	[EFilterOperator.IN]: 'in',
};

export const VIEW_CONFIGS: TViewConfigs = {
	[EViewType.TABLE]: {
		type: EViewType.TABLE,
		icon: 'UnorderedListOutlined',
		label: 'List',
	},
	[EViewType.BOARD]: {
		type: EViewType.BOARD,
		icon: 'AppstoreOutlined',
		label: 'Board',
	},
};

export const FORM_VALIDATION_RULES = {
	FIELD_NAME: {
		required: true,
		message: 'Field name is required',
		min: 2,
		minMessage: 'Field name must be at least 2 characters',
	},
	INTERNAL_KEY: {
		required: true,
		message: 'Internal key is required',
		pattern: /^[a-z][a-z0-9_]*$/,
		patternMessage:
			'Internal key must start with letter and contain only lowercase letters, numbers, and underscores',
	},
	FIELD_TYPE: {
		required: true,
		message: 'Field type is required',
	},
	OPTIONS: {
		required: true,
		message: 'At least one option is required for this field type',
		minLength: 1,
	},
};

export const PLACEHOLDERS = {
	SEARCH_CUSTOMERS: 'Search customers with AI (name, company, phone...)',
	FIELD_NAME: 'e.g., Service Type, VIP Customer, Preferred Time',
	INTERNAL_KEY: 'e.g., service_type, is_vip, preferred_time',
	FIELD_DESCRIPTION: 'e.g., What type of service does this customer usually need?',
	FIELD_OPTION: 'Option',
	SELECT_FIELD_TYPE: 'What kind of information is this?',
	SELECT_OPERATOR: 'Choose condition',
	SELECT_VALUE: 'Enter value',
};

export const MODAL_CONFIGS = {
	FIELD_MANAGER: {
		width: 800,
		centered: true,
		maskClosable: false,
		destroyOnClose: true,
	},
	CUSTOMER_FORM: {
		width: 600,
		centered: true,
		maskClosable: false,
		destroyOnClose: true,
	},
	FILTER_BUILDER: {
		width: 1000,
		centered: true,
		maskClosable: true,
		destroyOnClose: true,
	},
};

export const SEARCH_CONFIG = {
	debounceMs: 300,
	minSearchLength: 1,
	searchableFields: ['name', 'email', 'phone'],
	caseSensitive: false,
	highlightMatches: true,
};

export const BOARD_CONFIG = {
	cardMinHeight: 120,
	cardMaxHeight: 200,
	columnMinWidth: 280,
	columnMaxWidth: 350,
	maxCardsPerColumn: 50,
	defaultGroupBy: 'service_type',
};
